import React, { useState } from "react";

export const SailSquadSelect = ({current}) => {
  const [selectedDate, setSelectedDate] = useState(current);

  const handleDateChange = (event) => {
    const selectedDate = event.target.value;
    setSelectedDate(selectedDate);
    // Redirect to the corresponding link based on the selected date
    window.location.href = `https://register.thetravelsquad.com/${selectedDate}`;
  };

  return (
    <div>
      <select className="w-full p-2 border rounded" id="dateSelect" value={selectedDate} onChange={handleDateChange} style={{ fontWeight: 'bold', marginLeft: -4}}>
        <option value="sailsquad-2024">22nd June - 28th June</option>
        <option value="sailsquad-2024-2">29th June - 5th July</option>
      </select>
    </div>
  );
};
